import type { LucideIcon } from "lucide-react";

type FloatingItem = {
  icon: LucideIcon;
  className: string;
  color?: string;
  animation: "animate-float-slow" | "animate-float-medium" | "animate-float-fast";
};

export function FloatingIcons({ items }: { items: FloatingItem[] }) {
  return (
    <div className="pointer-events-none absolute inset-0 hidden overflow-hidden opacity-70 lg:block">
      {items.map(({ icon: Icon, className, color, animation }, i) => (
        <div key={i} className={`absolute ${className} ${animation}`}>
          <Icon className={`size-5 ${color ?? "text-teal-300/40"}`} strokeWidth={1.5} />
        </div>
      ))}
    </div>
  );
}
